import { LabelColor } from '@shared/components';

export enum UserStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  INVITATION_PENDING = 'INVITATION_PENDING',
}

export const USER_STATUS_TEXT: Record<UserStatus, string> = {
  ENABLED: 'Active',
  DISABLED: 'Inactive',
  INVITATION_EXPIRED: 'Expired',
  INVITATION_PENDING: 'Pending',
};

export const USER_COLOR_STATUS: Record<UserStatus, LabelColor> = {
  [UserStatus.ENABLED]: LabelColor.SUCCESS,
  [UserStatus.DISABLED]: LabelColor.GREY,
  [UserStatus.INVITATION_EXPIRED]: LabelColor.ERROR,
  [UserStatus.INVITATION_PENDING]: LabelColor.INFO,
};
